import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { defaultChildRoute } from "../legacy-redirects";

export const chargebackSettingsRoutes: PermissionedRouteObject[] = [
  {
    path: "chargebacks",
    handle: {
      get breadcrumb() {
        return t("Chargebacks");
      },
    },
    children: [
      defaultChildRoute("reclaim"),
      {
        path: "alerts",
        handle: {
          get breadcrumb() {
            return t("Alerts", {
              context: "merchant settings label for chargeback alerts",
            });
          },
        },
        lazy: async () => {
          const { ChargebacksAlertsSettingsPage } =
            await import("../../../../setting/chargebacks/chargebacks-alerts-settings-page");
          return { Component: ChargebacksAlertsSettingsPage };
        },
      },
      {
        path: "reclaim",
        handle: {
          get breadcrumb() {
            return "Reclaim";
          },
        },
        lazy: async () => {
          const { ChargebacksReclaimSettingsPage } =
            await import("../../../../setting/chargebacks/chargebacks-reclaim-settings-page");
          return { Component: ChargebacksReclaimSettingsPage };
        },
      },
      {
        path: "profile",
        handle: {
          get breadcrumb() {
            return t("{{productName}} Profile", {
              productName: "Reclaim",
              context:
                "merchant settings label for the profile of the official Reclaim product",
            });
          },
        },
        lazy: async () => {
          const { ChargebacksProfileSettingsPage } =
            await import("../../../../setting/chargebacks/chargebacks-profile-settings-page");
          return { Component: ChargebacksProfileSettingsPage };
        },
      },
      {
        path: "resolve",
        handle: {
          get breadcrumb() {
            return t("{{productName}}", {
              productName: "Resolve",
              context:
                "merchant settings label containing the official Resolve product name",
            });
          },
        },
        lazy: async () => {
          const { ChargebacksResolveSettingsPage } =
            await import("../../../../setting/chargebacks/chargebacks-resolve-settings-page");
          return { Component: ChargebacksResolveSettingsPage };
        },
      },
    ],
  },
];
